<template>
        
        <div>
    		<table v-if="!empty" class="order-list">
    			<tbody>
                    <tr 
                        class="order"
                        v-for="(item, groupdId) in store.groupedItems" 
                    >
                        <td class="order__image">
    						<a v-bind:href="item[0].link">
    							<div 
                                    class="order__thumb"
                                    v-bind:style="{ backgroundImage: 'url(\'' + getItemThumb(item[0]) + '\')' }"
                                ></div>
    						</a>
                        </td>
                        <td class="order__name" colspan="2">
                            <input type="hidden" v-bind:name="'product[' + groupdId + '][id]'" v-bind:value="item[0].id">
                            <input type="hidden" v-bind:name="'product[' + groupdId + '][quantity]'" v-bind:value="item.length">
                            
                            <a v-bind:href="item[0].link">
                                <span>{{ item.length + "x "  }}</span>
                                {{  item[0].title }}                  
                            </a>

                            <div class="order__options">
                                {{ trans("single_price") }} {{ getItemPrice(item[0]) | format_money }} {{ currency.label }}
                            </div>

                            <div v-if="item[0].selectedOptions" class="order__options">
                                <input 
                                    type="hidden" 
                                    v-for="selectedOption in item[0].selectedOptions" 
                                    v-bind:name="'product[' + groupdId + '][options][]'" 
                                    v-bind:value="selectedOption.id"
                                >

                                {{ getSelectedOptionTitles(item[0]) }}
                            </div>

                            <div class="order__price">
                            {{ getItemPrice(item[0]) * item.length | format_money }} {{ currency.label }}
                            </div>

                            <div class="form__error" v-show="item[0].error" v-html="item[0].error"></div>

                            <a  class="order__rmv"
                                href="#" 
                                v-on:click.prevent="removeGroup(groupdId)"
                            ></a>
    					</td>
                    </tr>
    				

                    <tr class="order__discount" v-if="hasGroupDiscount" style="border: 0">
                        <td></td>
                        <td >{{ trans("discount_message") }}</td>
                        <td colspan="2">{{ store.items[0].group_discount }}%</td>
                    </tr>

                    <tr class="order__discount" v-if="promoCodeDiscountAmount > 0" style="border: 0">
                        <td></td>
                        <td >{{ trans("promo_code_discount_message") }}</td>
                        <td colspan="2">{{ promoCodeDiscountAmount | format_money }} {{ currency.label }}</td>
                    </tr>
    		
    				<tr class="order__delivery">
                        <td></td>
    					<td >{{ trans("delivery") }}</td>
    					<td colspan="2">
                            <span v-if="!totalDeliveryPrice">{{ trans("free_delivery") }}</span>
                            <span v-else>
                                {{ totalDeliveryPrice | format_money }} {{ currency.label }}
                            </span>
                        </td>
    				</tr>

    				<tr class="order__sum">
                        <td></td>
    					<td >{{ trans("total") }}</td>
    					<td colspan="2">
                            {{ totalPrice | format_money }} {{ currency.label }}
                            <span v-if="currency.multiple">
                                / {{ (totalPrice * currency.rate) | format_money }} {{ currency.secondary_label }}
                            </span>
                        </td>
    				</tr>

    			</tbody>
    		</table>

            <div v-else>
                {{ trans("empty") }}
            </div>
        </div>

</template>

<script>
	export default {
        props: [
            "deliveryPrice",
            "freeShippingThreshold",
            "checkPromoCodeUrl",
            "oldPromoCode",
            "isWholesale",
            "translations",
            "errors",
            "currency"
        ],

        data() {
            return {
                store: CartItems,
                promoCodeDiscount: 0,
                promoCodeType: '',
                promoCodeReq: null,
                localErrors: []
            };
        },

        computed: {
            hasGroupDiscount() {
                let items = this.store.items;
                let hasDiscount = false;

                for (const item of items) {
                    let clientDiscount = this.isWholesale == false && item.promo_price == null && item.group_discount != '0.00';
                    let wholesalerDiscount = this.isWholesale == true && item.group_discount != '0.00';

                    if (clientDiscount || wholesalerDiscount) {
                        hasDiscount = true;
                    }
                }

                return hasDiscount;
            },

            promoCodeDiscountAmount() {
                let discount = 0;

                if (this.totalProductsPrice) {
                    if (this.promoCodeType == "sum") {
                        discount = this.totalProductsPrice <= this.promoCodeDiscount
                            ? this.totalProductsPrice
                            : this.promoCodeDiscount;
                    } else if (this.promoCodeType == "percent") {
                        const groupedItems = this.store.groupedItems;

                        for (const groupId in groupedItems) {
                            let quantity = groupedItems[groupId].length;
                            let items = groupedItems[groupId];
                            
                            if (items[0].promo_price == null && (parseFloat(items[0].group_discount, 10) < this.promoCodeDiscount)) {
                                let percent = this.promoCodeDiscount - parseFloat(items[0].group_discount, 10);
                                let productDiscount = parseFloat(this.getItemPrice(items[0]) * quantity * percent / 100, 10).toFixed(2);

                                discount += parseFloat(productDiscount, 10);
                            }
                        }
                    }
                }

                return discount;
            },

            empty() {
                return this.store.empty();
            },

            totalPrice() {
                return this.totalProductsPrice ? this.totalProductsPrice + this.totalDeliveryPrice - this.promoCodeDiscountAmount : 0;
            },

            totalProductsPrice() {
                let price = 0;
                let groupedItems = this.store.groupedItems;

                for (const groupId in groupedItems) {
                    let quantity  = groupedItems[groupId].length;
                    let items     = groupedItems[groupId];
                    let itemPrice = this.getItemPrice(items[0]).toFixed(2);

                    price += parseFloat(itemPrice) * quantity;
                }

                return price;
            },

            totalDeliveryPrice() {
                if (typeof this.store.delivery.price === "undefined") {
                    return 0;
                }

                if (this.store.delivery.price == 0 || this.store.delivery.price === null) {
                    return 0;
                }

                if (this.store.delivery.freeShippingThreshold) {
                    let productsPrice = this.totalProductsPrice;

                    if (productsPrice > this.store.delivery.freeShippingThreshold) {
                        return 0;
                    }
                }

                return parseFloat(this.store.delivery.price, 10);
            },
        },

        methods: {
            remove(index) {
                this.store.remove(index);
            },

            removeGroup(groupId) {
                this.store.removeGroup(groupId);
            },

            getItemPrice(item) {
                let discount = parseFloat(item.group_discount, 10);
                let clientPrice = item.promo_price ? parseFloat(item.promo_price, 10) : parseFloat(item.price, 10);

                let price = this.isWholesale == true 
                    ? parseFloat(item.wholesale_price, 10) - parseFloat(item.wholesale_price, 10) * discount / 100
                    : (item.promo_price ? clientPrice : clientPrice - clientPrice * discount / 100);

                for (let i = 0, len = item.selectedOptions.length; i < len; i++) {
                    let finalClientPrice = parseFloat(item.selectedOptions[i].promo_price 
                        ? item.selectedOptions[i].promo_price 
                        : item.selectedOptions[i].price, 10);
                    let finalWholesalePrice = parseFloat(item.selectedOptions[i].wholesale_price, 10);

                    price += this.isWholesale == true
                        ? finalWholesalePrice - finalWholesalePrice * discount / 100
                        : (item.selectedOptions[i].promo_price ? finalClientPrice : finalClientPrice - finalClientPrice * discount / 100);
                }

                return price;
            },

            getItemThumb(item) {
                if (item.thumb) {
                    return item.thumb.thumb;
                }

                return null;
            },

            getSelectedOptionTitles: function(item) {
                let result = [];

                for (let i = 0, len = item.selectedOptions.length; i < len; i++) {
                    result.push(item.selectedOptions[i].title);
                }

                return result.join(", ");
            },

            checkPromoCode: function(jqEl) {
                if (this.promoCodeReq) {
                    this.promoCodeReq.abort();
                }

                let _this = this;
                let promoCode = jqEl.parent().find("input[name='promo_code']").val();
                let promoCodeMessage = jqEl.closest(".form__group").find(".promo-code-message");

                this.promoCodeReq = $.ajax({
                cache: false,
                url: _this.checkPromoCodeUrl + "?code=" + promoCode,
                method: 'get',
                beforeSend: function() {
                    jqEl.addClass("btn--loading")
                        .attr("disabled", true)
                        .prop("disabled", true);
                },
                success: function(response) {
                    if (typeof response === "string") {
                        promoCodeMessage.text(response).parent().removeClass("hidden");

                        _this.promoCodeDiscount = 0;
                        _this.promoCodeType = '';
                    } else {
                        _this.promoCodeDiscount = parseFloat(response.discount);
                        _this.promoCodeType = response.discount_type;
                        
                        let message = _this.promoCodeDiscountAmount > 0
                            ? response.message
                            : _this.trans("errors.promo_code_not_applicable");

                        promoCodeMessage.text(message).parent().removeClass("hidden");
                    }
                },
                error: function(jqXhr) {
                    let status = jqXhr.status;
                    let response = jqXhr.responseText;

                    promoCodeMessage.parent().addClass("hidden");

                    if (status == 500) {
                        alert("Грешка на сървъра");
                    } else {
                        alert(response);
                    }
                },
                complete: function() {
                    setTimeout(function() {
                        jqEl.removeClass("btn--loading")
                            .removeProp("disabled")
                            .removeAttr("disabled");
                    }, 500);
                }
                });
            },

            trans(key) {
                return this.translations[key];
            },
        },

        watch: {
            totalPrice: function(newValue) {
                this.$emit("change-total-price", newValue);
            }
        },

        beforeMount() {
            let _this = this;
            this.localErrors = JSON.parse(this.errors);

            const groupKeys = Object.keys(this.store.groupedItems);

            groupKeys.forEach(function(groupId) {
                const error = _this.localErrors["product." + groupId]
                    ? _this.localErrors["product." + groupId][0]
                    : false;

                _this.store.groupedItems[groupId].map(function(item) {
                    item.error = error;
                    return item;
                });
            })
        },

        mounted() {
            // On component mounted
            let _this = this;

            $("#check-promo-code-btn").on("click", function(e) {
                e.preventDefault();
                _this.checkPromoCode($(this));                
            });

            if (this.oldPromoCode) {
                $("#check-promo-code-btn").trigger("click");
            }

            this.$emit("change-total-price", this.totalPrice);
        }
    }
</script>